import React, { useState } from 'react';
import { ShoppingCart } from '@phosphor-icons/react';
import { resolveImageUrl } from '../../services/api';

export function ProductImageGallery({ product }) {
  const [activeImage, setActiveImage] = useState(0);
  const images = product.images?.length > 0 ? product.images : (product.image_url ? [product.image_url] : []);

  if (images.length === 0) {
    return (
      <div className="aspect-square bg-[#1A1A1A] border border-[#333333] rounded-sm flex items-center justify-center">
        <ShoppingCart className="w-24 h-24 text-[#333333]" />
      </div>
    );
  }

  return (
    <div>
      <div className="aspect-square bg-[#1A1A1A] border border-[#333333] rounded-sm overflow-hidden mb-3" data-testid="product-main-image">
        <img
          src={resolveImageUrl(images[activeImage] || images[0])}
          alt={product.name}
          className="w-full h-full object-cover"
          onError={(e) => { e.target.onerror = null; e.target.src = ''; e.target.className = 'hidden'; }}
        />
      </div>
      {images.length > 1 && (
        <div className="flex gap-2 overflow-x-auto" data-testid="product-image-gallery">
          {images.map((img, i) => (
            <button
              key={img}
              onClick={() => setActiveImage(i)}
              className={`w-16 h-16 sm:w-20 sm:h-20 rounded-sm overflow-hidden border-2 shrink-0 transition-colors ${
                activeImage === i ? 'border-[#22C55E]' : 'border-[#333333] hover:border-[#999999]'
              }`}
              data-testid={`gallery-thumb-${i}`}
            >
              <img src={resolveImageUrl(img)} alt="" className="w-full h-full object-cover" onError={(e) => { e.target.onerror = null; e.target.src = ''; e.target.className = 'hidden'; }} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
